<template>
  <div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { WebSocketManager } from '@/util/websocket.js'

export default {
  name: 'WebSocket',
  computed: {
    ...mapGetters(['getTranslation'])
  },
  props: {
    url: String,
    instanceId: {
      type: String,
      default: () => `ws_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`
    }
  },
  components: {

  },
  data() {
    return {
      socketApp: {
        connected: false,
        connecting: false,
      },
      wsManager: null, // 独立的 WebSocket 管理器实例
    }
  },
  created() {
    this.initWebSocket();
  },
  beforeDestroy() {
    this.cleanupWebSocket();
  },
  methods: {
    initWebSocket() {
      // 创建独立的 WebSocket 管理器实例
      this.wsManager = new WebSocketManager({
        url: this.url,
        reconnectInterval: 3000,
        maxReconnectAttempts: 5,
        heartbeatInterval: 30000
      });

      // 注册事件处理器
      this.wsManager.on('message', this.handleWebSocketMessage);
      this.wsManager.on('open', this.handleWebSocketOpen);
      this.wsManager.on('close', this.handleWebSocketClose);
      this.wsManager.on('error', this.handleWebSocketError);

      // 自动连接
      this.connectWebSocket();
    },
    
    cleanupWebSocket() {
      if (this.wsManager) {
        // 清理事件监听器
        this.wsManager.off('message', this.handleWebSocketMessage);
        this.wsManager.off('open', this.handleWebSocketOpen);
        this.wsManager.off('close', this.handleWebSocketClose);
        this.wsManager.off('error', this.handleWebSocketError);
        
        // 断开连接
        this.disconnectWebSocket();
        this.wsManager = null;
      }
    },

    handleWebSocketMessage(obj) {
      // 只处理当前实例相关的消息      
      this.$emit('receive-message', obj);
    },

    handleWebSocketOpen(event) {
      this.$emit('open-socket', event);
      this.socketApp.connected = true;
      this.socketApp.connecting = false;    
    },

    handleWebSocketClose(event) {
      this.$emit('close-socket', event);
      this.socketApp.connected = false;
      this.socketApp.connecting = false;      
    },

    handleWebSocketError(error) {
      console.error(`WebSocket [${this.instanceId}] error:`, error);
    },

    connectWebSocket() {
      if (this.wsManager) {
        this.socketApp.connecting = true;
        this.wsManager.connect();
      }
    },

    disconnectWebSocket() {
      if (this.wsManager) {
        this.wsManager.close();
        this.socketApp.connected = false;
      }
    },

    sendMessage(message) {
      if (this.wsManager && this.wsManager.getStatus().isConnected) {
        const success = this.wsManager.send(message);
        if (!success) {
          console.error(`WebSocket [${this.instanceId}] send error`);
        }
      } else {
        console.error(`WebSocket [${this.instanceId}] not connected`);
      }
    },

    // 获取当前 WebSocket 状态
    getWebSocketStatus() {
      return this.wsManager ? this.wsManager.getStatus() : { isConnected: false };
    }
  }
}
</script>

<style scoped></style>